module.exports = __webpack_public_path__ + "static/media/moire_og.01ff1753.jpg";